// John Eldhose 20190503
import { RestfulPost } from './Restful';

export async function updateCache(option, value) {
  const data = { option: option, value: value };
  const cache = await RestfulPost('updateCache', data, (response) => {
      return response['data'];
    }, (error) => {
      console.log(error);
      return false;
    }
  );
  return cache;
}



// WEBPACK FOOTER //
// ./src/Api/updateCache.js